import type { ReactElement } from 'react';
import type { StoreProductsParams } from '@/entities/product';
import { clearDrawerFilters, toActiveFilterChips } from './active-filter-chips';
import { StoreActiveFilterChip } from './store-active-filter-chip';

interface StoreActiveFiltersProps {
  readonly filters: StoreProductsParams;
  /** 1페이지 되돌림은 페이지 컴포넌트의 몫이다. */
  readonly onFiltersChange: (filters: StoreProductsParams) => void;
}

/**
 * 툴바 아래 걸린 조건 칩 줄 — 드로어를 열지 않고도 무엇이 걸렸는지 보고 하나씩 풀 수 있다.
 * 색상·최소 주문 수량·단가만 다룬다. 걸린 조건이 없으면 줄 자체를 그리지 않는다.
 */
export const StoreActiveFilters = ({
  filters,
  onFiltersChange,
}: StoreActiveFiltersProps): ReactElement | null => {
  const chips = toActiveFilterChips(filters);

  if (chips.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
      <ul aria-label="적용된 필터" className="flex flex-wrap gap-2">
        {chips.map((chip) => (
          <StoreActiveFilterChip
            key={chip.key}
            label={chip.label}
            swatchStyle={chip.swatchStyle}
            onRemove={() => onFiltersChange(chip.next)}
          />
        ))}
      </ul>
      <button
        type="button"
        onClick={() => onFiltersChange(clearDrawerFilters(filters))}
        className="cursor-pointer text-[13px] text-muted-foreground underline underline-offset-4 transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        전체 해제
      </button>
    </div>
  );
};
